import React, { useState, useEffect } from "react";
import { EpreuvesList2 } from "../EpreuvesList2";
import { loadEpreuves } from "../requests";

export const QueryTriathlon = ({ regionFilter, yearFilter }) => {
  const [epreuves, setEpreuves] = useState([]);

  const fetchData = async () => {
    try {
      const epreuvesResult = await loadEpreuves({
        region: regionFilter,
        name: "",
        month: 0,
        year: yearFilter,
        type: ["Jeunes", "XXS", "XS", "S", "M", "L", "XL", "XXL"],
        relay: "",
        Elevation_bike: 0,
        bibs: 25000,
        Swimenv: ["Piscine", "Lac", "Mer", "Rivière", "Plan d'eau", "0"],
        crosstri: ["1", "0"],
      });
      setEpreuves(epreuvesResult);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [regionFilter]);

  return (
    <div className="container visible-md">
      <div className="row my-2 font-weight-bold">
        <h5 className="font-weight-bold">{epreuves.length} triathlons</h5>
      </div>
      <div className="row">
        <EpreuvesList2 epreuves={epreuves} filterByRegion={regionFilter} />
      </div>
    </div>
  );
};
